import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import { RiBarChartBoxLine } from "react-icons/ri";
import PartnerImg from "../../assets/images/partner-img.jpg";
import "./PartnerAreaCall.css";

export default function PartnerAreaCall(props) {
  return (
    <div>
      <Container>
        <Row>
          <Col className="partner-call-first-col">
            <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
              <RiBarChartBoxLine
                style={{ color: props.iconColor }}
                className="partner-call-icon"
              />{" "}
              PARCEIRO REDE DE VANTAGENS
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="partner-call-third-col">
            <p style={{ color: props.textColor, fontSize: props.textSize }}>
              Sua empresa já é parceira da Rede de Vantagens? Acesse a área
              dedicada aos nossos parceiros e ofereça descontos a todos os
              nossos clientes.
            </p>
            <CustomButton
              className="primary-btn"
              variant="primary"
              href="https://centraldocliente.grupokrause.com.br/conveniados-login"
              rel="noopener noreferrer"
              target="_blank"
              icon=""
              content="ÁREA DO PARCEIRO"
              backgroundColor={props.btnColor}
              fontFamily="Unageo-Bold"
              fontColor={props.white}
              fontSize={20}
              width={260}
              borderColor={props.btnColor}
              disabled={false}
            />
          </Col>
          <Col
            lg={{ span: 6, order: "first" }}
            className="partner-call-second-col"
          >
            <div className="partner-call-img-container">
              <img src={PartnerImg} alt="Parceiro" />
              <div className="partner-call-img-overlay" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
